import { Link } from '@mui/material';
import { clsx } from 'clsx';

import { Tooltip } from '@atom/mui';
import { WorkOrderField } from '@atom/types/work';
import { DETAIL_FIELD_WIDTH } from '@atom/utilities/taskUtilities';

import classes from './workOrderFields.module.css';

interface Props {
  field: WorkOrderField;
  width?: string;
}

const WorkOrderHyperlinkField = ({ field, width }: Props) => {
  return (
    <div style={width ? { width } : undefined}>
      <div
        className={clsx(classes.fieldTitle, classes.hyperlinkTitle)}
        style={{ maxWidth: width ?? DETAIL_FIELD_WIDTH }}
      >
        {field.title}
      </div>
      <Tooltip title={field.hyperlink}>
        <Link href={field.hyperlink} target="_blank">
          {field.value}
        </Link>
      </Tooltip>
    </div>
  );
};

export default WorkOrderHyperlinkField;
